/**
 * Created by mac on 10/28/20
 */

cleverapps.UI.ScrollBarContainer = cc.Node.extend({
});

cleverapps.UI.ScrollView = cc.ClippingNode.extend({
    ctor: function (content, options) {
        this.options = options || {};
        this.direction = cleverapps.UI.ScrollView.DIR_NONE;

        this.min = cc.p(0, 0);
        this.max = cc.p(0, 0);

        this.onUpdatePositionListener = function () {};
        this.onUpdateZoomListener = function () {};

        this._super();

        if (this.options.clipping === undefined || this.options.clipping) {
            this.setClippingEnabled(true);
        }
        this.setAnchorPoint(0.5, 0.5);

        this.centerNode = new cc.Node();
        this.addChild(this.centerNode);

        if (this.options.scrollBarEnabled !== false) {
            this.barContainer = new cleverapps.UI.ScrollBarContainer();
            this.addChild(this.barContainer, 2);
            this.barContainer.setCascadeOpacityEnabled(true);
            this.barContainer.setOpacity(0);
            this.barContainer.runAction(new cc.Sequence(
                new cc.DelayTime(0.3),
                new cc.FadeTo(0.3, 255)
            ));
            this.barHandler = new ScrollBarHandler(this, this.options.customScrollbar);
        }

        if (this.options.dock) {
            this.smallContentDocker = new SmallContentDocker(this, this.options.dock);
        }

        this.zoom = 1;
        if (this.options.zoom) {
            this.zoomHandler = new cleverapps.UI.ZoomHandler(this, this.options.zoom);
        }

        this.scrollHandler = new cleverapps.UI.ScrollHandler(this, {
            mouseScroll: !this.options.zoom && this.options.mouseScroll !== false,
            touchScroll: this.options.touchScroll,
            outOfBoundaryScale: this.options.outOfBoundaryScale,
            inertialScrollFactor: this.options.inertialScrollFactor,
            snapHandler: this.options.snapHandler,
            movementThreshold: this.options.movementThreshold,
            bounceEnabled: this.options.bounceEnabled
        });

        this.innerContent = content;
        this.innerContent.setAnchorPoint(0.5, 0.5);
        this.innerContent.setPosition(0, 0);
        this.centerNode.addChild(content);

        if (this.options.childrenVisibility !== false) {
            this.visibilityHandler = new VisibilityHandler(this);
        }

        this.scheduleUpdate();
    },

    setContentSize: function (width, height) {
        const oldWidth = this.width;
        const oldHeight = this.height;

        this._super(width, height);

        if (oldWidth !== this.width || oldHeight !== this.height) {
            if (this.barContainer) {
                this.barContainer.setContentSize(this.getContentSize());
            }

            this.centerNode.setPosition(this.width / 2, this.height / 2);
            this.calcBorders();
            if (this.smallContentDocker) {
                this.smallContentDocker.dock();
            }
            this.scrollToPoint(this.normalizePoint(this.getContainerPosition()));
        }
    },

    updateVisibility: function () {
        if (this.innerContent.setVisibleRect) {
            this.innerContent.setVisibleRect(this.getVisibleRect());
        }

        if (this.visibilityHandler) {
            this.visibilityHandler.updateVisibility();
        }
    },

    getVisibleRect: function () {
        return cc.rect(
            Math.round(-this.innerContent.x - this.min.x),
            Math.round(-this.innerContent.y - this.min.y),
            Math.round(this.width / this.centerNode.getScale()),
            Math.round(this.height / this.centerNode.getScale())
        );
    },

    isVisiblePoint: function (point) {
        return cc.rectContainsPoint(this.getVisibleRect(), point);
    },

    isVisibleNode: function (node) {
        const box = node.getGlobalBoundingBox();
        const min = this.innerContent.convertToNodeSpace(cc.p(box.x, box.y));
        const max = this.innerContent.convertToNodeSpace(cc.p(box.x + box.width, box.y + box.height));
        const visible = this.getVisibleRect();

        return min.x >= visible.x && min.y >= visible.y
            && max.x <= visible.x + visible.width && max.y <= visible.y + visible.height;
    },

    calcBorders: function () {
        if (this.width + this.height === 0) {
            this.min = cc.p(0, 0);
            this.max = cc.p(0, 0);
            return;
        }

        const s = this.centerNode.getScale();

        this.min = cc.p(
            Math.floor(-this.innerContent.width / 2 + this.width / s / 2),
            Math.floor(-this.innerContent.height / 2 + this.height / s / 2)
        );
        if (this.min.x > 0) {
            this.min.x = 0;
        }
        if (this.min.y > 0) {
            this.min.y = 0;
        }
        this.max = cc.p(
            Math.ceil(this.innerContent.width / 2 - this.width / s / 2),
            Math.ceil(this.innerContent.height / 2 - this.height / s / 2)
        );
        if (this.max.x < 0) {
            this.max.x = 0;
        }
        if (this.max.y < 0) {
            this.max.y = 0;
        }

        this.updateDirection();
        if (this.barHandler) {
            this.barHandler.reset();
        }
    },

    scrollToDefault: function () {
        this.scrollTo(cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT);
    },

    updateInnerContent: function () {
        this.calcBorders();
        if (this.visibilityHandler) {
            this.visibilityHandler.reset();
        }
        if (this.smallContentDocker) {
            this.smallContentDocker.dock();
        }
        this.scrollToPoint(this.normalizePoint(this.getContainerPosition()));
    },

    outOfBoundariesVector: function (target, padding) {
        const paddingX = (padding && padding.x) || 0;
        const paddingY = (padding && padding.y) || 0;
        switch (target) {
            case cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT:
                target = cc.p(this.min.x + paddingX, this.max.y + paddingY);
                break;
            case cleverapps.UI.ScrollView.SCROLLS.CENTER:
                target = cc.p(paddingX, paddingY);
                break;
            case cleverapps.UI.ScrollView.SCROLLS.LOWER_RIGHT:
                target = cc.p(this.max.x + paddingX, this.min.y + paddingY);
                break;
            default:
                if (target instanceof cc.Node) {
                    target = this.innerContent.convertToNodeSpace(cc.rectGetCenter(target.getGlobalBoundingBox()));
                }

                target = cc.p(
                    target.x - this.innerContent.width / 2 - paddingX,
                    target.y - this.innerContent.height / 2 - paddingY
                );
                break;
        }

        return target;
    },

    scrollTo: function (target, duration, options) {
        options = options || {};
        const callback = options.callback || function () {};

        if (target === undefined) {
            callback();
            return;
        }

        target = this.normalizePoint(this.outOfBoundariesVector(target, options.padding));

        if (!duration) {
            this.scrollToPoint(target);
            callback();
        } else {
            options.duration = duration;
            options.targetPoint = true;
            const easing = options.easing || cc.easeBackInOut();
            this.runAction(new cc.ScrollAction(target, options).easing(easing)).setFinalize(callback);
        }
    },

    scrollBy: function (delta, duration, options) {
        const target = cc.pAdd(delta, this.getContainerPosition());
        target.x += this.innerContent.width / 2;
        target.y += this.innerContent.height / 2;
        this.scrollTo(target, duration, options);
    },

    update: function (dt) {
        this._super(dt);
        this.scrollHandler.processAutoScroll(dt);
    },

    normalizePoint: function (p) {
        return {
            x: Math.max(this.min.x, Math.min(this.max.x, p.x)),
            y: Math.max(this.min.y, Math.min(this.max.y, p.y))
        };
    },

    getContainerPosition: function () {
        return cc.p(-this.innerContent.x, -this.innerContent.y);
    },

    getCurrentPosition: function () {
        const p = this.innerContent.getPosition();
        return {
            x: -p.x + this.innerContent.width / 2,
            y: -p.y + this.innerContent.height / 2
        };
    },

    scrollToPoint: function (p) {
        this.innerContent.setPosition(-p.x, -p.y);

        this.updateVisibility();
        if (this.barHandler) {
            this.barHandler.updatePos();
        }

        this.onUpdatePositionListener();
    },

    getScrollPercent: function () {
        const fullX = this.max.x - this.min.x;
        const fullY = this.max.y - this.min.y;

        return {
            x: fullX !== 0 ? (this.innerContent.x - this.min.x) / fullX : 0,
            y: fullY !== 0 ? (this.innerContent.y - this.min.y) / fullY : 0
        };
    },

    // direction picks the axis to move along; without it a DIR_BOTH scroll would always
    // scroll vertically, which leaves its horizontal scrollbar dragging the wrong axis.
    scrollToPercent: function (percent, duration, direction) {
        percent = Math.min(100, Math.max(0, percent));
        let target;

        if (direction === undefined) {
            // eslint-disable-next-line no-bitwise
            direction = this.direction & cleverapps.UI.ScrollView.DIR_VERTICAL
                ? cleverapps.UI.ScrollView.DIR_VERTICAL
                : cleverapps.UI.ScrollView.DIR_HORIZONTAL;
        }

        // The untouched axis has to be carried over as a container coordinate, not as the
        // inner content's position: scrollToPoint negates whatever it gets, so reusing
        // innerContent.x/y here mirrors that axis instead of leaving it alone.
        const current = this.getContainerPosition();

        if (direction === cleverapps.UI.ScrollView.DIR_VERTICAL) {
            const newY = (this.max.y - this.min.y) * percent / 100 + this.min.y;

            target = cc.p(current.x, newY);
        } else {
            const newX = (this.max.x - this.min.x) * percent / 100 + this.min.x;
            target = cc.p(newX, current.y);
        }

        if (!duration) {
            this.scrollToPoint(target);
        } else {
            this.runAction(new cc.ScrollAction(target, {
                duration,
                targetPoint: true
            }).easing(cc.easeBackInOut()));
        }
    },

    setScrollAction: function (action) {
        this.stopScrollAction();

        this._scrollAction = action;
    },

    stopScrollAction: function () {
        if (this._scrollAction) {
            this.stopAction(this._scrollAction);
            this._scrollAction.stop();
            delete this._scrollAction;
            this.scrollHandler.afterContainerMove();
        }
    },

    stopAutoScroll: function () {
        this.stopScrollAction();
        this.scrollHandler.stopAutoScroll();
    },

    updateDirection: function () {
        if (this.options.direction) {
            this.direction = this.options.direction;
        } else {
            this.direction = cleverapps.UI.ScrollView.DIR_BOTH;
            if (this.min.y === this.max.y) {
                this.direction ^= cleverapps.UI.ScrollView.DIR_VERTICAL;
            }
            if (this.min.x === this.max.x) {
                this.direction ^= cleverapps.UI.ScrollView.DIR_HORIZONTAL;
            }
        }
    },

    setDirection: function (direction) {
        this.options.direction = direction;
        this.updateDirection();
        if (this.smallContentDocker) {
            this.smallContentDocker.undock();
        }
        this.updateInnerContent();
    },

    getInnerContainer: function () {
        return this.innerContent;
    },

    setBarPadding: function (padding) {
        if (this.barHandler) {
            this.barHandler.setPadding(padding);
        }
    },

    afterContainerSizeChanged: function (newSize) {
        this.stopScrollAction();
        this.stopAutoScroll();

        const point = this.innerContent.parent.convertToNodeSpace(this.innerContent.convertToWorldSpace(cc.p(0, 0)));
        const currentContainerPosition = this.innerContent.parent.convertToWorldSpace(cc.p(this.innerContent.x - this.innerContent.width / 2, this.innerContent.y + this.innerContent.height / 2));

        this.innerContent.setContentSize(newSize);
        this.calcBorders();

        const newContainerPosition = this.innerContent.parent.convertToNodeSpace(currentContainerPosition);

        newContainerPosition.x += this.innerContent.width / 2;
        newContainerPosition.y -= this.innerContent.height / 2;

        this.innerContent.setPosition(this.normalizePoint(newContainerPosition));
        this.updateInnerContent();

        const newPoint = this.innerContent.parent.convertToNodeSpace(this.innerContent.convertToWorldSpace(cc.p(0, 0)));
        const offset = cc.pSub(point, newPoint);

        return offset;
    },

    getCropContainer: function () {
        if (this.smallContentDocker && this.smallContentDocker.isDocked()) {
            const contentBox = this.innerContent.getBoundingBox();

            return cc.rect(this.width / 2 + contentBox.x, this.height / 2 + contentBox.y, contentBox.width, contentBox.height);
        }

        return cc.rect(0, 0, this.width, this.height);
    }
});

cleverapps.UI.ScrollView.SCROLLS = {
    UPPER_LEFT: 0,
    CENTER: 1,
    LOWER_RIGHT: 2
};

cleverapps.UI.ScrollView.DIR_NONE = 0;
cleverapps.UI.ScrollView.DIR_VERTICAL = 1;
cleverapps.UI.ScrollView.DIR_HORIZONTAL = 2;
cleverapps.UI.ScrollView.DIR_BOTH = cleverapps.UI.ScrollView.DIR_VERTICAL | cleverapps.UI.ScrollView.DIR_HORIZONTAL;
